const error = state => state.error
const loading = state => state.loading
const maintenance = state => state.maintenance

export default {
  error,
  loading,
  maintenance
}
